export const END_POINT_PRODUCT = import.meta.env.VITE_END_POINT_PRODUCT
export const END_POINT_USER = import.meta.env.VITE_END_POINT_USER
export const END_POINT_LOGGER = import.meta.env.VITE_END_POINT_LOGGER
export const END_POINT_PDF = import.meta.env.VITE_END_POINT_PDF
export const END_POINT_PAYMENT = import.meta.env.VITE_END_POINT_PAYMENT
export const END_POINT_STRIPE = import.meta.env.VITE_END_POINT_STRIPE
export const BREVO_KEY = import.meta.env.VITE_BREVO_API_KEY
